<template>
  <div :class="$style.container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="修改邮箱" name="first">
        <div v-if="step === 1">
          <Item title="验证方式">
            <el-select v-model="checkType" :disabled="codeSending" style="width: 200px" @change="onCheckTypeChange">
              <el-option
                v-for="item in checkTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </Item>
          <Item :title="checkType === 0 ? '手机号码' : '邮箱'">
            <el-input :value="checkType === 0 ? userInfo.mobile : userInfo.email" disabled></el-input>
          </Item>
          <Item title="验证码">
            <el-input v-model="captcha" maxlength="6" @input="onCodeInput"></el-input>
            <CaptchaButton ref="captchaButton" :checkType="checkType" />
          </Item>

          <Item title=" ">
            <Button type="primary" :loading="loading" @click="nextStep">
              下一步
            </Button>
          </Item>
        </div>

        <div v-else>
          <Item title="旧邮箱地址">
            <el-input v-model="oldEmail" disabled></el-input>
          </Item>
          <Item title="新邮箱地址">
            <el-input v-model="newEmail"></el-input>
          </Item>
          <Item title=" ">
            <Button type="primary" :loading="loading" @click="submit">
              确定
            </Button>
          </Item>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div :class="$style.goBack" @click="goBack">返回</div>
  </div>
</template>

<script>
import CaptchaButton from "@components/CaptchaButton.vue";

import { mapState } from "vuex";
import { postVerifyCode, updateEmail } from "@server";

export default {
  name: "SafeEmailUpdate",
  components: {
    CaptchaButton,
  },
  data() {
    return {
      activeName: "first",
      step: 1,
      loading: false,

      checkType: 0,
      checkTypeList: [],
      codeSent: false,

      captcha: "", // 验证身份验证码
      captchaResult: "",

      oldEmail: "",
      newEmail: "",
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    codeSending() {
      return this.$refs.captchaButton && this.$refs.captchaButton.countdown > 0;
    },
  },
  watch: {
    userInfo: {
      handler(v) {
        this.oldEmail = v.email;
        this.initCheckType();
      },
      immediate: true,
    },
  },
  methods: {
    initCheckType() {
      this.checkTypeList = [];
      if (this.userInfo.mobile != null && this.userInfo.mobile.length > 0) {
        this.checkType = 0;
        this.checkTypeList.push({ value: 0, name: '手机验证' });
      } else {
        this.checkType = 1;
      }
      if (this.userInfo.email != null && this.userInfo.email.length > 0) {
        this.checkTypeList.push({ value: 1, name: '邮箱验证' });
      }
    },

    onCheckTypeChange() {
      // Reset captcha button when switching type
      this.codeSent = false;
      this.$nextTick(() => {
        if (this.$refs.captchaButton) {
          this.$refs.captchaButton.reset();
        }
      });
    },

    onCodeInput() {
      this.captcha = this.captcha.replace(/[^\d]/g, '');
    },

    async nextStep() {
      if (this.captcha.length < 6) {
        this.$message({
          message: `请输入${this.captcha && "正确的"}验证码`,
          type: "warning",
        });
        return;
      }

      this.loading = true;
      const res = await postVerifyCode({ code: this.captcha, type: this.checkType });

      if (res.code === 200) {
        this.captchaResult = res.data.verifyCode;
        this.captcha = "";
        this.step = 2;
      } else {
        this.$message({ message: res.message, type: "error" });
      }
      this.loading = false;
    },

    checkSubmit() {
      if (!this.newEmail) {
        this.$message({ message: `请输入新邮箱地址`, type: "warning" });
        return false;
      }
      return true;
    },

    async submit() {
      if (!this.checkSubmit()) return;

      this.loading = true;
      const data = {
        newEmail: this.newEmail,
        verify: this.captchaResult,
      };
      const res = await updateEmail(data);

      if (res.code === 200) {
        this.$message({ message: `认证邮件已发送，请尽快验证！`, type: "success" });
        setTimeout(() => {
          this.$router.push("/user/safe");
        }, 1000);
      } else {
        this.$message({ message: res.message, type: "error" });
      }
      this.loading = false;
    },

    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  position: relative;

  :global {
    .el-tabs {
      box-shadow: $box-shadow;

      ::v-deep .el-tabs__header {
        background-color: $white;
        border-bottom: $border-1;
      }
      ::v-deep .el-tabs__content {
        min-height: rem(500);
        box-shadow: unset;
      }
    }

    .gl-item {
      margin-bottom: rem(40);

      ::v-deep .gl-item__left {
        width: rem(160);
        padding-left: rem(20);
      }
    }
  }

  .goBack {
    position: absolute;
    top: 0;
    right: rem(60);
    padding: 10px 5px;
    font-size: rem(14);
    color: #333;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      color: $theme-color;
    }
  }
}
</style>